import React from 'react';
import { Stack } from '@mui/material';
import { withStyles } from '@material-ui/core';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import styles from './styles';
import RecommendationListForm from '../../../Components/Forms/RecommendationListForm/RecommendationListForm';
import VBreadcrumbs from '../../../Venti-UI-Kit/VBreadcrumbs/VBreadcrumbs';
import { useEditRecommendationListPage } from './hook';
import BackofficePageTitle from '../../../Components/BackofficePageTitle/BackofficePageTitle';

const EditRecommendationListPage = ({ classes }) => {
  const { list } = useEditRecommendationListPage();

  return (
    <PageContainer title="Editar Lista de Recomendación">
      <VBreadcrumbs pageTitle="Edición" />

      <Stack className={classes.pageContentContainer}>
        <BackofficePageTitle mainTitle="Editar Lista de Recomendación" />
        {list && <RecommendationListForm list={list} />}
      </Stack>
    </PageContainer>
  );
};

export default withStyles(styles)(EditRecommendationListPage);
